module.exports = __webpack_public_path__ + "img/instaimg.71b6917a.png";